import { render, staticRenderFns } from "./TimeBEStatistics.vue?vue&type=template&id=9e589cd6&"
import script from "./TimeBEStatistics.vue?vue&type=script&lang=js&"
export * from "./TimeBEStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports